import request from '@/utils/request'

/**
 * 首页相关 API
 */

// 完成统计
export function indexInfo (data) {
  return request({
    url: '/course/index/index',
    method: 'post',
    data
  })
}

// 学习时长
export function studyDuration (data) {
  return request({
    url: '/course/index/study_duration',
    method: 'post',
    data
  })
}

// 今日排行榜
export function rankingListToday (data) {
  return request({
    url: '/course/index/ranking_list',
    method: 'post',
    data
  })
}

// 签到列表
export function signList (data) {
  return request({
    url: '/course/sign/sign_list',
    method: 'post',
    data
  })
}

// 签到
export function signIn (data) {
  return request({
    url: '/course/sign/sign_in',
    method: 'post',
    data
  })
}

// 学习记录 统计图
export function monthStudyDuration (data) {
  return request({
    url: '/course/index/month_study_duration',
    method: 'post',
    data
  })
}
